import { useTranslation } from "react-i18next";
import { useMemo } from "react";
import { DateTime } from "luxon";

import type { TimePeriod } from "@utils/chart-data-conversions/timelines";

interface DateRangePickerQuickSelect {
  label: string;
  period: TimePeriod;
}

interface QuickSelectSection {
  // title: string;
  options: DateRangePickerQuickSelect[];
}

export const useQuickPicks = (): QuickSelectSection[] => {
  const { t } = useTranslation();

  return useMemo<QuickSelectSection[]>(() => {
    const todayStart = DateTime.local().startOf("day");

    return [
      {
        options: [
          // NOTE: data sync is ~6hr target lag, which would make a "today" view
          // misleading (probably lead to data syncing confusion, wasting CX time)
          // {
          //   label: t("dateRangePicker.today"),
          //   period: {
          //     start: todayStart,
          //     end: todayStart.plus({ days: 1 }),
          //     granularity: "day",
          //   },
          // },
          {
            label: t("dateRangePicker.yesterday"),
            period: {
              start: todayStart.minus({ days: 1 }),
              end: todayStart,
              granularity: "day",
            },
          },
          {
            label: t("dateRangePicker.lastNDays", { n: 7 }),
            period: {
              start: todayStart.minus({ days: 7 }),
              end: todayStart,
              granularity: "day",
            },
          },
          {
            label: t("dateRangePicker.lastNDays", { n: 30 }),
            period: {
              start: todayStart.minus({ days: 30 }),
              end: todayStart,
              granularity: "day",
            },
          },
        ],
      },
      {
        options: [
          {
            label: t("dateRangePicker.thisMonth"),
            period: {
              start: todayStart.startOf("month"),
              end: todayStart.endOf("month"),
              granularity: "day",
            },
          },
          {
            label: t("dateRangePicker.lastMonth"),
            period: {
              start: todayStart.minus({ months: 1 }).startOf("month"),
              end: todayStart.minus({ months: 1 }).endOf("month"),
              granularity: "day",
            },
          },
          {
            label: t("dateRangePicker.lastNMonths", { n: 3 }),
            period: {
              start: todayStart.minus({ months: 3 }),
              end: todayStart,
              granularity: "week",
            },
          },
          {
            label: t("dateRangePicker.lastNMonths", { n: 12 }),
            period: {
              start: todayStart.minus({ months: 12 }),
              end: todayStart,
              granularity: "month",
            },
          },
        ],
      },
    ];
  }, [t]);
};
